import React from 'react';
import buildResourcePath from '@lib/buildResourcePath'
import MyAccountCard from './MyAccountCard';
import * as Row from '../layout/Row';
import Button from '../common/Button';
import Modal from '@lib/components/common/Modal'


export default class MyAccountPrivacyCard extends MyAccountCard {
    title = __('Privacy information')
    endpoint = 'RemoveAccount'

    state = {
        deleteModalIsOpen: false,
        passwordConfirmation: ''
    }

    rednderBody() {
        return (
            <div></div>
        );
    }


    renderSaveButton() {
        return (<React.Fragment></React.Fragment>);

    }

    onPrivacyButtonClick = e => {
        window.location.href = buildResourcePath("Policy/PolicyRules");
    }

    onGDPRButtonClick = e => {
        window.location.href = buildResourcePath("Policy/GDPR");
    }

    onDeleteMyData = e => {
        this.setState({deleteModalIsOpen: true});

    }

    deleteConfirmed() {

        this.myAccountAPIService.post(this.endpoint, {passwordConfirmation: this.state.passwordConfirmation}).then((response) => {
            {
                if (response.status == 200) {
                    window.location.href = "Login";
                }
            }
        })
        this.setState({deleteModalIsOpen: false});
    }

    renderModalBody() {
        return (
            <div>
                {this.renderPasswordField(__('Enter password'), this.state.passwordConfirmation, newValue => this.setState({passwordConfirmation: newValue}))}
            </div>
        );
    }

    renderButtons() {
        return (
            <React.Fragment>
                <div className="align-right">
                    <Button size={Button.Size.Small} color={Button.Color.Gray} onClick={this.onPrivacyButtonClick}>
                        {__('Privacy policy')}
                    </Button>
                </div>
                <div className="align-right">
                    <Button size={Button.Size.Small} color={Button.Color.Gray} onClick={this.onGDPRButtonClick}>
                        {__('GDPR information')}
                    </Button>
                </div>
                <div className="align-right">
                    <Button size={Button.Size.Small} color={Button.Color.Gray} onClick={this.onDeleteMyData}>
                        {__('Delete my account')}
                    </Button>
                </div>

                <Modal isOpen={this.state.deleteModalIsOpen} onClose={() => this.setState({deleteModalIsOpen: false})}
                       closeTimeoutMS={125}>
                    <Modal.Header>{__('Delete my account')}</Modal.Header>
                    {/* <Modal.Body>{__('Do you want to remove all information about you?')}</Modal.Body> */}
                    <Modal.Body>{this.renderModalBody()}</Modal.Body>
                    <Modal.Footer>
                        <Button theme={Button.Theme.BorderOnly}
                                onClick={() => this.setState({deleteModalIsOpen: false})}>{__('Cancel')}</Button>
                        <Button theme={Button.Theme.BorderOnly}
                                onClick={() => this.deleteConfirmed()}>{__('Delete')}</Button>
                    </Modal.Footer>
                </Modal>
            </React.Fragment>
        );

    }
}